import {Injectable} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {CommonService} from './common.service';

@Injectable({
    providedIn: 'root'
})
export class ParentService {
    public parents: MatTableDataSource<any> = new MatTableDataSource<any>();

    constructor(private commonService: CommonService) {
    }

    async getParents(filter: any) {
        try {
            this.commonService.postDataNoPromise('parents', filter).subscribe((data: any) => {
                this.parents = new MatTableDataSource<any>(data);
            });
        } catch (e) {
            throw e;
        }
    }

    async registerParent(parentData: any) {
        await this.commonService.postRequest(`parents/register`, {parentData});
    }
}
